import styled from '@emotion/styled';

export const NotApplicable = styled('div')((p) => ({
  color: p.theme.custom.colors.gray.w500,
  fontSize: p.theme.custom.fontSize.m
}));
